export default __webpack_public_path__ + "static/media/it.f7547d11.ico";